import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";

import FormInput from "../../../common/forms/FormInput";

import { ValType } from "../../../utils/ValidationFunctions";

import styles from "./NewsTOPSliderSettingsItem.module.scss";

type Props = {
  newsList: Array<{ img: string | File; url: string; isExternal: boolean }>;
  handleInputChange: (index: number, value?: string | File | boolean) => void;
  removeItem: (index: number) => void;
};
const NewsTOPSliderSettingsItem: React.FC<Props> = ({
  newsList,
  handleInputChange,
  removeItem,
}) => {
  const { t } = useTranslation();
  return (
    <ul>
      {newsList.map((news, i) => (
        <li className={styles["newsItem"]} key={i}>
          <div className={styles["newsItem__input"]}>
            <span className={styles["newsItem__input__label"]}>
              スライダー画像
            </span>
            <div className={styles["newsItem__input__img"]}>
              <img
                src={
                  news.img
                    ? typeof news.img === "string"
                      ? news.img
                      : URL.createObjectURL(news.img)
                    : undefined
                }
                className={styles["newsItem__input__img__preview"]}
              />
              <FormInput
                handler={(val) => {
                  return handleInputChange(i, val);
                }}
                type="file"
                label="画像を追加"
                name="news_img"
                id={`news_img${i}`}
                label_class={styles["newsItem__input__img__label"]}
                val_type={ValType.File}
              />
            </div>
          </div>
          <div className={styles["newsItem__input"]}>
            <span className={styles["newsItem__input__label"]}>URL</span>
            <FormInput
              handler={(val) => {
                return handleInputChange(i, val);
              }}
              type="text"
              label=""
              name="news_url"
              initial_value={news.url}
              style_class={styles["newsItem__input__text"]}
            />
          </div>
          <div className={styles["newsItem__input"]}>
            <div className={styles["checkbox"]}>
              <FormInput
                handler={() => handleInputChange(i, !news.isExternal)}
                type="checkbox"
                id={`checkbox${i}`}
                label=""
                name="isExternal"
                initial_value={news.isExternal.toString()}
              />
              <label htmlFor={`checkbox${i}`}>別タブで開く</label>
            </div>
          </div>
          <button
            type="button"
            className={styles["newsItem__input__delete-btn"]}
            onClick={() => removeItem(i)}
          >
            <FontAwesomeIcon icon={["fal", "trash-alt"]} />
            {t("削除")}
          </button>
        </li>
      ))}
    </ul>
  );
};

export default NewsTOPSliderSettingsItem;
